import request from "@/utils/request.js";
// let path = "/api";
const MessageCenter = {
  /**
   * 查询
   * @param department @type String 查询的部门名称，模糊匹配（LIKE 查询）
   * @param startTime @type String 起始时间
   * @param endTime @type String 截止时间
   * @param page @type  Number 页码
   * @param pageSize @type Number 条数
   */
  queryList: async (data) => {
    return await request("post", "/feedback-center/list", data);
  },
  /**
   * 添加或修改
   * @param id @type String 新增不要 修改必传
   * @param name @type String 姓名
   * @param department @type String 所属部门
   * @param title @type String  职务/头衔
   * @param comment @type String  留言内容
   * @param checkStatus @type String  审核状态：0-未审核，1-已审核
   * @param Number @type String  联系电话
   * @param createTime @type String  格式为 yyyy-MM-dd hh:mm:ss
   */
  addOrUpDateList: async (data) => {
    return await request("post", "/feedback-center/add", data);
  },

  /**
   * 删除
   * @param id @type String 删除id
   */
  delList: async (data) => {
    return await request("get", "/feedback-center/logic-del", data);
  },
};
export default MessageCenter;



// WEBPACK FOOTER //
// ./src/api/messageCenter.js